export const resources = [
  'applications',
  'application-groups',
  'application-links',
  'user-groups',
  'chats',
  'chat-groups',
  'chat-templates',
] as const;
type Resource = (typeof resources)[number];

export const ROUTES = {
  NOT_ALLOWED: '/not-allowed',
  HOME: '/',
  APPLICATION: {
    BASE: '/applications',
    BY_ID: (id: string | number) => `/applications/${id}`,
  },
  CHATS: {
    BASE: '/chats',
    BY_ID: (chatId: string | number) => `/chats/${chatId}`,
  },
  ADMIN: {
    BASE: '/admin',
    APPLICATIONS: '/admin/applications',
    APPLICATION_GROUPS: '/admin/application-groups',
    APPLICATION_LINKS: '/admin/application-links',
    USER_GROUPS: '/admin/user-groups',

    CHATS: '/admin/chats',
    CHATS_GROUPS: '/admin/chats/groups',
    CHATS_TEMPLATES: '/admin/chats/templates',
    SEND_MESSAGE: '/admin/chats/send-message',

    EDIT: (resource: Resource | ':resource', id: string | number) => `/admin/${resource}/${id}`,
    CREATE: (resource: Resource | ':resource') => `/admin/${resource}/create`,
  },
  LOGIN: '/login',
};
